import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";
import reducers from './rootReducer';
import { createBrowserHistory } from 'history';
import { persistStore, persistReducer } from 'redux-persist'
import localforage from 'localforage';

const sagaMiddleware = createSagaMiddleware();

export const history = createBrowserHistory();

const persistConfig = {
    key: 'root',
    storage: localforage
}

const persistedReducer = persistReducer(persistConfig, reducers(history))

export const store = createStore(
    persistedReducer,
    composeWithDevTools(applyMiddleware(routerMiddleware(history), thunk, sagaMiddleware))
);

export const persistor = persistStore(store)

